import { ChronoUnit, Duration, LocalDate } from "@js-joda/core";
import React from "react";
import { STRINGS } from "../../../strings";
import { translate } from "../../../translate";
import { formatDuration } from "../../../utils/dateUtils";
import { getTaskDatesRangeText } from "../../../utils/taskUtils";
import Flex from "../../Generic/Flex";

interface Props {
  startDate: LocalDate;
  dueDate: LocalDate;
  durationMinutes: number | null;
}

const AvailableTaskListItemDetails = (props: Props) => {
  const durationMinutes = props.durationMinutes;

  const taskDatesRange = React.useMemo(
    () => getTaskDatesRangeText(props.startDate, props.dueDate),
    [props.startDate, props.dueDate]
  );

  return (
    <Flex className="AvailableTasksListItem__Details" direction="column" yGap={4}>
      <div>{`${translate(STRINGS.TIME_ESTIMATION)}: ${formatDurationText(durationMinutes)}`}</div>
      <span>{taskDatesRange}</span>
    </Flex>
  );
};

function formatDurationText(durationMinutes: number | null): string {
  return durationMinutes === null
    ? "Unspecified"
    : formatDuration(Duration.of(durationMinutes, ChronoUnit.MINUTES));
}

export default AvailableTaskListItemDetails;
